// src/App.jsx
import { BrowserRouter as Router, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { AuthWrapper, RequireAdmin } from './components/AuthWrapper';
import { GraphQLProvider } from './graphql';
import { ImpersonationProvider } from './context/ImpersonationContext';
import { WorkflowNavigationProvider } from './context/WorkflowNavigationContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Tenders from './pages/Tenders';
import Operations from './pages/Operations';
import Subscriptions from './pages/Subscriptions';
import Permissions from './pages/Permissions';
import Settings from './pages/Settings';
import Login from './pages/Login';
import './index.css';
import { useState } from 'react';
import BetaSignups from "./pages/BetaSignups.jsx";
import System from "./pages/System.jsx";
import DeepCrawl from "./pages/DeepCrawl.jsx";
import Sessions from "./pages/Sessions.jsx";
import Storage from "./pages/Storage.jsx";
import Features from "./pages/Features.jsx";
import TeamInvitations from "./pages/TeamInvitations.jsx";
import SavedSearchReports from "./pages/SavedSearchReports.jsx";
import EventActions from "./pages/EventActions.jsx";
import SalesCockpit from "./pages/SalesCockpit.jsx";
import Engagement from "./pages/Engagement.jsx";

// Legacy route redirects
const JobsRedirect = () => {
    const [searchParams] = useSearchParams();
    const jobId = searchParams.get('jobId');
    return <Navigate to={`/operations?tab=jobs${jobId ? `&jobId=${jobId}` : ''}`} replace />;
};
const WorkflowsRedirect = () => {
    const [searchParams] = useSearchParams();
    const runId = searchParams.get('runId');
    return <Navigate to={`/operations?tab=workflows${runId ? `&runId=${runId}` : ''}`} replace />;
};
const ScheduledJobsRedirect = () => <Navigate to="/operations?tab=scheduled" replace />;

function App() {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <Router>
            <AuthWrapper>
                <GraphQLProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/*"
                            element={
                                <RequireAdmin>
                                    <ImpersonationProvider>
                                        <WorkflowNavigationProvider>
                                            <div className="flex h-screen text-white">
                                                <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
                                                <div className="flex-1 flex flex-col overflow-hidden">
                                                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                                                    <main className="flex-1 overflow-x-hidden overflow-y-auto">
                                                        <Routes>
                                                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                                                            <Route path="/dashboard" element={<Dashboard />} />
                                                            <Route path="/sales" element={<SalesCockpit />} />
                                                            <Route path="/engagement" element={<Engagement />} />
                                                            <Route path="/sales/cockpit" element={<Navigate to="/sales" replace />} />
                                                            <Route path="/users" element={<Users />} />
                                                            <Route path="/companies" element={<Companies />} />
                                                            <Route path="/team-invitations" element={<TeamInvitations />} />
                                                            <Route path="/tenders" element={<Tenders />} />
                                                            <Route path="/operations" element={<Operations />} />
                                                            {/* Legacy route redirects */}
                                                            <Route path="/jobs" element={<JobsRedirect />} />
                                                            <Route path="/scheduled-jobs" element={<ScheduledJobsRedirect />} />
                                                            <Route path="/workflows" element={<WorkflowsRedirect />} />
                                                            <Route path="/deep-crawl" element={<DeepCrawl />} />
                                                            <Route path="/beta-signups" element={<BetaSignups />} />
                                                            <Route path="/subscriptions" element={<Subscriptions />} />
                                                            <Route path="/permissions" element={<Permissions />} />
                                                            <Route path="/sessions" element={<Sessions />} />
                                                            <Route path="/settings" element={<Settings />} />
                                                            <Route path="/system" element={<System />} />
                                                            <Route path="/storage" element={<Storage />} />
                                                            <Route path="/features" element={<Features />} />
                                                            <Route path="/saved-search-reports" element={<SavedSearchReports />} />
                                                            <Route path="/event-actions" element={<EventActions />} />
                                                        </Routes>
                                                    </main>
                                                </div>
                                            </div>
                                        </WorkflowNavigationProvider>
                                    </ImpersonationProvider>
                                </RequireAdmin>
                            }
                        />
                    </Routes>
                </GraphQLProvider>
            </AuthWrapper>
        </Router>
    );
}

export default App;